import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PM_CLIENTS_SUBNAV_HOST, type PmClientsSubnavHost } from './pm-clients-subnav-host';

/** Clients screen sub-header: Back to Clients (on a sub-page) and the Schedule / Communication / Submissions / Letters / AML tabs. */
@Component({
  selector: 'pm-clients-subnav',
  standalone: true,
  imports: [],
  templateUrl: './pm-clients-subnav.component.html',
  styleUrl: './pm-clients-subnav.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PmClientsSubnavComponent {

  /** What this section still reads from the workspace (see pm-clients-subnav-host.ts). */
  private readonly workspace = inject(PM_CLIENTS_SUBNAV_HOST);

  get clientsWorkspaceSection() {
    return this.workspace.clientsWorkspaceSection;
  }

  getCustomLabel(...args: Parameters<PmClientsSubnavHost['getCustomLabel']>): ReturnType<PmClientsSubnavHost['getCustomLabel']> {
    return this.workspace.getCustomLabel(...args);
  }

  setClientsWorkspaceSection(...args: Parameters<PmClientsSubnavHost['setClientsWorkspaceSection']>): ReturnType<PmClientsSubnavHost['setClientsWorkspaceSection']> {
    return this.workspace.setClientsWorkspaceSection(...args);
  }
}
